import { OptionGrid } from "@ui/components/OptionGrid";
import type { SupportedLocale } from "@ui/lib/locale-data";

interface LocaleGridProps {
  locales: SupportedLocale[];
  currentLocale: string;
  onSelect: (code: string) => void;
  /** Accessible name for the grid's radio group (the section heading's text). */
  ariaLabel: string;
}

export function LocaleGrid({ locales, currentLocale, onSelect, ariaLabel }: LocaleGridProps) {
  return (
    <OptionGrid
      ariaLabel={ariaLabel}
      items={locales.map((locale) => ({ id: locale.code, primary: locale.nativeName, secondary: locale.region }))}
      onSelect={onSelect}
      selectedId={currentLocale}
    />
  );
}
